module.exports = __webpack_public_path__ + "assets/009eadeaeb078bb501adedd54ac8e3e0.png";